import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor() {}

  /**
   * Returns true when the current environment is PayBev International.
   * Use this to branch UI, API behavior, or feature flags by brand.
   */
  isInternational(): boolean {
    return environment.brand?.toLowerCase() === 'paybevinternational';
  }
}
